<script>
	/** @type {{ href: string; imageSrc: string; name: string }[]} */
	export let logos;
</script>

<div class="logos-list">
	{#each logos as { href, imageSrc, name }}
		<a {href} target="_blank">
			<img src={imageSrc} alt={name} loading="lazy" decoding="async" />
		</a>
	{/each}
</div>

<style>.logos-list{align-items:center;display:inline-flex;flex-wrap:wrap;gap:4rem;padding:2rem;justify-content:center}</style>
